import {Component, forwardRef, Injector} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";

/**
 * Search grid column to render percentage values
 */
@Component({
    selector: "wbo-percentage-column",
    templateUrl: "./percentage-column.component.html",
    styleUrls: ["./percentage-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => PercentageColumnComponent), multi: true}
    ]
})
export class PercentageColumnComponent extends AbstractColumnComponent {
    constructor(injector: Injector) {
        super(injector);
    }
}
